import React from 'react';
import DashboardSidebar from './DashboardSidebar';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

/**
 * DashboardLayout - Contenedor principal para el CRM
 * Proporciona el Sidebar y el área de contenido principal.
 */
const DashboardLayout = ({ children }) => {
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();
    const userEmail = localStorage.getItem('userEmail') || 'organizador@visiopadel.com';
    const userName = localStorage.getItem('userName') || 'Organizador';

    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    return (
        <div 
            className={`flex min-h-screen transition-colors duration-500 ${theme === 'dark' ? 'dark' : ''}`}
            style={{ backgroundColor: theme === 'dark' ? '#0f172a' : '#ffffff' }}
        >
            {/* Sidebar fijo */}
            <DashboardSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

            {/* Contenido principal */}
            <div className="flex-1 flex flex-col min-h-screen">
                {/* Topbar del Dashboard */}
                <header className="bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700 h-16 md:h-20 flex items-center justify-between px-4 md:px-8 sticky top-0 z-40 transition-colors duration-300">
                    <div className="flex items-center gap-2 md:gap-4">
                        {/* Mobile Toggle Button */}
                        <button
                            onClick={() => setIsSidebarOpen(true)}
                            className="md:hidden p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>

                        <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400 font-medium hidden sm:flex">
                            <Link to="/" className="hover:text-primary-600 transition-colors">VisioPadel Web</Link>
                            <span>/</span>
                            <span className="text-gray-900 dark:text-white font-bold">Dashboard de Gestión</span>
                        </div>
                    </div>

                    <div className="flex items-center gap-3 sm:gap-6">
                        {/* Buscador */}
                        <div className="hidden lg:flex items-center bg-gray-100 dark:bg-slate-700/50 px-4 py-2 rounded-xl group focus-within:bg-white dark:focus-within:bg-slate-700 focus-within:ring-2 focus-within:ring-primary-500/20 border border-transparent focus-within:border-primary-200 transition-all">
                            <span className="text-gray-400">🔍</span>
                            <input
                                type="text"
                                placeholder="Buscar pozos o jugadores..."
                                className="bg-transparent border-none focus:ring-0 text-sm w-64 ml-2 outline-none dark:text-white dark:placeholder-gray-400"
                            />
                        </div>

                        {/* Theme Toggle */}
                        <button 
                            onClick={toggleTheme}
                            className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-yellow-400 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-all"
                            title={theme === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
                        >
                            <span className="text-xl">{theme === 'dark' ? '☀️' : '🌙'}</span>
                        </button>

                        {/* Notificaciones */}
                        <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg relative transition-all">
                            <span className="text-xl">🔔</span>
                            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-slate-800"></span>
                        </button>

                        <div className="h-8 w-px bg-gray-200 dark:bg-slate-700 mx-1 sm:mx-2"></div>

                        {/* Perfil */}
                        <div className="flex items-center gap-3">
                            <div className="text-right hidden sm:block">
                                <p className="text-sm font-bold text-gray-900 dark:text-white leading-none mb-1">{userName}</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 leading-none">{userEmail}</p>
                            </div>
                            <div className="h-10 w-10 rounded-xl bg-primary-100 border border-primary-200 flex items-center justify-center text-primary-700 font-black shadow-sm">
                                {userName.charAt(0)}
                            </div>
                        </div>
                    </div>
                </header>

                {/* Área de Contenido */}
                <main className="p-4 sm:p-6 lg:p-8 flex-grow overflow-x-hidden">
                    {children}
                </main>

                {/* Footer sencillo para el CRM */}
                <footer className="py-6 px-8 border-t border-gray-100 dark:border-slate-800 text-center text-xs text-gray-400 font-medium">
                    &copy; 2025 VisioPadel CRM - Panel de Administración v1.0
                </footer>
            </div>
        </div>
    );
};

export default DashboardLayout;
